import api from './api';
import { CPB_URL } from './servers';

export const fetchDownloads = () => api.post(`${CPB_URL}/descargas/getColaDescarga`, {});

export const fetchFolioDescarga = (data) => api.post(`${CPB_URL}/descargas/getFolioDescarga`, data);

export const fetchDescargaArchivos = (data) =>
  api.post(`${CPB_URL}/descargas/getArchivoDescarga`, data);

export const fetchLinks = () => api.post(`${CPB_URL}/descargas/getColaEnlaces`, {});

export const fetchFolioEnlaces = (data) => api.post(`${CPB_URL}/descargas/getFolioDescarga`, data);
